<template>
  <div class="py-2">
    <div v-if="dataRows.id != 0">
    
      <label :for="label" class="block text-xss font-medium text-gray-700">
        {{label}}
      </label>
      <div v-if="description" class="text-gray-500 text-xs">
        {{description}}
      </div>    


      <div v-if="required && filteredDataRows.length == 0">

        <router-link to="/settings/integration/emails" >

        <div class="border p-4 rounded-lg mt-4 hover:bg-gray-50">
          <div class="text-xss text-rose-600">
            Conta de E-mail Necessária
          </div>
          <div class="mb-3 text-base font-normal text-gray-500">
            Você precisa adicionar uma conta de e-mail para continuar.
          </div>
          <div>
            <div class="text-blue-500 hover:text-blue-600 font-medium">
              Clique aqui para adicionar uma conta de e-mail
            </div>
          </div>
        </div>
      </router-link>

      </div>

      <Combobox v-model="selected" v-else>
        <div class=" relative mt-1">
          <div class="relative">          
            <ComboboxButton v-if="selected != ''" @click="unSelected()" class="absolute right-8 top-3">
              <XMarkIcon class="h-4 cursor-pointer"/>
            </ComboboxButton>
            <ComboboxInput class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-slate-500 focus:border-slate-500 sm:text-xss" :displayValue="(item) => item.name"  @change="searchTo" />
            <ComboboxButton class="absolute inset-y-0 right-0 flex items-center pr-2" >
              <ArrowsUpDownIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
            </ComboboxButton>
          </div>
          <TransitionRoot leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0" @after-leave="query = ''">        
            <ComboboxOptions class=" z-10 absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
              <div v-if="filteredDataRows.length === 0 && query !== ''" class="relative cursor-default select-none py-2 px-4 text-gray-700">
                Not found
              </div>
              <ComboboxOption v-for="item in filteredDataRows" as="template" :key="item.id" :value="item" v-slot="{ selected, active }">
                <li @click="update(item)" class="relative cursor-default select-none py-2 pl-10 pr-4" :class="{ 'bg-slate-600 text-white': active, 'text-gray-900': !active,}">
                  <span class="truncate flex" :class="{ 'font-medium': selected, 'font-normal': !selected }">
                    <div  class="pr-2">
                      
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="h-5 w-5" viewBox="0 0 485 485"  xml:space="preserve">
                        <path d="M413.974,71.026C368.171,25.225,307.274,0,242.5,0S116.829,25.225,71.026,71.026C25.225,116.829,0,177.726,0,242.5
                            s25.225,125.671,71.026,171.474C116.829,459.775,177.726,485,242.5,485c32.731,0,64.491-6.414,94.397-19.063l-11.688-27.63
                            C299.022,449.384,271.194,455,242.5,455C125.327,455,30,359.673,30,242.5S125.327,30,242.5,30S455,125.327,455,242.5
                            c0,51.323-31.534,74.699-60.834,74.699c-29.299,0-60.833-23.375-60.833-74.699c0-50.086-40.747-90.833-90.833-90.833
                            s-90.833,40.748-90.833,90.833s40.747,90.833,90.833,90.833c29.655,0,56.034-14.286,72.622-36.335
                            c4.248,8.577,9.594,16.336,16.04,23.113c16.613,17.468,38.988,27.087,63.004,27.087c24.017,0,46.392-9.62,63.005-27.087
                            C475.377,300.97,485,274.132,485,242.5C485,177.726,459.775,116.829,413.974,71.026z M242.5,303.333
                            c-33.543,0-60.833-27.29-60.833-60.833s27.29-60.833,60.833-60.833s60.833,27.29,60.833,60.833S276.043,303.333,242.5,303.333z"/>
                      </svg>                    
                    </div>
                    {{ item.email }} - {{ item.name }}
                  </span>
                  <span v-if="selected" class="absolute inset-y-0 left-0 flex items-center pl-3" :class="{ 'text-white': active, 'text-teal-600': !active }">
                    <CheckIcon class="h-5 w-5" aria-hidden="true" />
                  </span>
                </li>
              </ComboboxOption>
            </ComboboxOptions>
          </TransitionRoot>
        </div>
      </Combobox>
      </div>
      <div v-else>

        <label :for="label" class="block text-sm font-medium text-gray-700">
          {{label}}
        </label>
        <div v-if="description" class="text-gray-500 text-xs">
          {{description}}
        </div>
      
        <div class="border border-dashed p-4 rounded-md bg-gray-700 text-white mt-2">
          <div class="text-sm font-bold">Atenção: Você ainda não adicionou uma conta de email</div>
          <div>
            <router-link to="/settings/integration/emails" class="text-sm font-bold text-blue-500 hover:text-blue-600">Clique aqui para adicionar</router-link>
          </div>
        </div>
         
      </div>
  </div>
</template>

<script>


import {
  Combobox,
  ComboboxInput,
  ComboboxButton,
  ComboboxOptions,
  ComboboxOption,
  TransitionRoot,
} from '@headlessui/vue'

import { CheckIcon, ArrowsUpDownIcon, XMarkIcon } from '@heroicons/vue/24/solid'

export default {

  name: 'DropDownSearchMails',
  props: {
    label: String,
    description: String,    
    settings_departaments_id: String,
    show_user: {
      type: Boolean,
      default: true,
    },
    value: [String, Object, Boolean],  
    required: {
      type: Boolean,
      default: false,
    },
    
  },
  data() {
    return {
      urlMails: 'core/components/fields/integrationMail',
      dataRows: [],
      query: '',
      item: {},
      selected: '',

    }
  },
  components: {
    Combobox,
    ComboboxInput,
    ComboboxButton,
    ComboboxOptions,
    ComboboxOption,
    TransitionRoot,
    CheckIcon,
    ArrowsUpDownIcon,
    XMarkIcon,

  },
  methods: {

    async getMails(){
    await this.$ApiService.post(this.urlMails, this.params).then(response => {
        this.dataRows = response.data;
        
        // Se apenas um e-mail está disponível, selecione-o automaticamente
        if (this.dataRows.length === 1) {
            this.selected = this.dataRows[0];
            this.$emit('update:modelValue', this.selected.id);
        } else if (this.value) {
            // Se houver um valor selecionado, tente restaurar esse estado
            this.selected = this.dataRows.find(element => element.id === this.value) || '';
            if (this.selected) {
                this.$emit('update:modelValue', this.selected.id);
            }
        }
    });
},


    searchTo($event) {
      this.query = $event.target.value
    },

    unSelected() {
      this.selected = '',
      this.$emit('update:modelValue', null);
    },

    update(item) {
      this.item = item
      this.$emit('update:modelValue', this.item.id);
    },

    search(item) {
      return (item.name||"").toLowerCase().indexOf((this.query||"").toLowerCase()) > -1 || (item.email||"").toLowerCase().indexOf((this.query||"").toLowerCase()) > -1
    },

  },

  computed: {
    filteredDataRows() {

      // Impede que sejam mostrados dados (apenas não retorna nada)
      if(!this.dataRows){
        return ''
      }

      return this.dataRows.filter(item => {
        if(this.search(item)){ return item.name}          
      });

    },
  },
  watch: {
    settings_departaments_id(newValue) {
      this.selected = '';
      this.$emit('update:modelValue', null);
      this.getMails();
    },
  },

  async created() {    
    await this.getMails();

    // Start selected
    if(this.value){
      for (let index = 0; index < this.dataRows.length; index++) {
        const element = this.dataRows[index];
        if(element.id == this.value){
          this.selected = element;
          this.$emit('update:modelValue', element.id);
        }
      }
    }


  },
}

</script>